import Hero from "@/sections/Hero";
import EmergencyBanner from "@/sections/EmergencyBanner";
import ServicesTeaser from "@/sections/teasers/ServicesTeaser";
import WorkTeaser from "@/sections/teasers/WorkTeaser";
import AboutTeaser from "@/sections/teasers/AboutTeaser";
import Contact from "@/sections/Contact";

const HomePage = () => {
  return (
    <>
      <Hero />
      <EmergencyBanner />
      <ServicesTeaser />
      <WorkTeaser />
      <AboutTeaser />
      <Contact />
    </>
  );
};

export default HomePage;
